import { Accordion } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMuiAccordion = styled(Accordion)`
  width: 100%;
  background-color: #fafaff;
  border-radius: 8px;

  &.Mui-expanded {
    margin: 0;
  }
`;
